import { Type } from "class-transformer";
import { observable } from "mobx";

export default class OutgoingPayGateReversalPayment {
  @observable id: string;
  @Type(() => Date)
  @observable
  authorizedAt: Date;
  @observable variableSymbol: string;
  @observable paidAmount: number;
  @observable cardNumber: string;
  @observable arn: string;
}
